import { pianoAnalytics } from 'piano-analytics-js';
import { whitelistedEvents, whitelistedProperties } from './helpers/whitelist';
import { logFn } from './utils';
const ACCEPTED_PRIVACY_MODES = ['exempt', 'optout'];
const wrappedAnalytics = {
  sendEvent: (...args) => {
    if (pianoAnalytics.getConfiguration('site')) {
      return pianoAnalytics.sendEvent.call(pianoAnalytics, ...args);
    }
    if (global.__DEV__) {
      logFn('sendEvent', 'No "site" configuration set: Aborting action.');
    }
    return undefined;
  },
  sendEvents: (...args) => {
    if (pianoAnalytics.getConfiguration('site')) {
      return pianoAnalytics.sendEvents.call(pianoAnalytics, ...args);
    }
    if (global.__DEV__) {
      logFn('sendEvents', 'No "site" configuration set: Aborting action.');
    }
    return undefined;
  },
  setProperties: (...args) => pianoAnalytics.setProperties.call(pianoAnalytics, ...args)
};
function setConfiguration(trackingConfiguration) {
  const {
    site,
    collectDomain,
    debug
  } = trackingConfiguration;
  pianoAnalytics.setConfigurations({
    site,
    collectDomain
  });
  pianoAnalytics.privacy.include.events(whitelistedEvents, ['exempt']);
  pianoAnalytics.privacy.include.properties(whitelistedProperties, ['exempt']);
  if (!ACCEPTED_PRIVACY_MODES.includes(pianoAnalytics.privacy.getMode())) {
    pianoAnalytics.privacy.setMode('exempt');
  }
  if (global.__DEV__ && debug) {
    const originalFn = {
      ...wrappedAnalytics
    };
    wrappedAnalytics.sendEvent = (...args) => {
      try {
        logFn('sendEvent', ...args);
        return originalFn.sendEvent(...args);
      } catch (err) {
        return logFn('sendEvent err', err);
      }
    };
    wrappedAnalytics.sendEvents = (...args) => {
      try {
        logFn('sendEvents', ...args);
        return originalFn.sendEvents(...args);
      } catch (err) {
        return logFn('sendEvents err', err);
      }
    };
    wrappedAnalytics.setProperties = (...args) => {
      try {
        logFn('setProperties', ...args);
        return originalFn.setProperties(...args);
      } catch (err) {
        return logFn('setProperties err', err);
      }
    };
  }
  return {
    site: pianoAnalytics.getConfiguration('site'),
    collectDomain: pianoAnalytics.getConfiguration('collectDomain')
  };
}
export { setConfiguration, wrappedAnalytics };